module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo_loop"
  }, [_c('div', {
    staticClass: "player_centre"
  }, [_c('div', {
    staticClass: "player_responsive"
  }, [_c('uep-player', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded),
      expression: "loaded"
    }],
    staticClass: "player",
    attrs: {
      "standalone": _vm.standalone,
      "query": _vm.query
    },
    on: {
      "readyPlayer": _vm.readyPlayer
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8213622a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demoComponents/Loop.vue
// module id = 166
// module chunks = 1